<template>
  <div>
    <div class="card bg-light mb-0">
      <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Emergency Contact</h6>
      </div>
      <div class="card-body bg-white position-relative">
          <b-row align-v="center" class="loader" v-if="is_saving">
              <b-col>
                  <b-spinner></b-spinner>
                  <br><br>
                  <strong>Loading</strong>
              </b-col>
          </b-row>
          <b-form @submit.prevent="save">
              <b-form-group label="Name:" description="This field is required">
                  <b-form-input v-model="form.name" type="text" required size="sm"></b-form-input>
              </b-form-group>
              <b-form-group label="Relationship:" description="This field is required">
                  <b-form-input v-model="form.relationship" type="text" required size="sm"></b-form-input>
              </b-form-group>
              <b-form-group label="Home Number:" description="This field is required">
                  <b-form-input v-model="form.home" type="text" required size="sm"></b-form-input>
              </b-form-group>
              <b-form-group label="Mobile Number:" description="This field is required">
                  <b-form-input v-model="form.mobile" type="text" required size="sm"></b-form-input>
              </b-form-group>
              <b-form-group label="Work Number:" description="This field is required">
                  <b-form-input v-model="form.work" type="text" required size="sm"></b-form-input>
              </b-form-group>
          <div class="text-right mt-3">
            <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
      mixins:[SwalMixin],
      data() {
        return {
          is_saving:false,
          form:{
            id:-1,
              relationship:'',
              name:'',
              home:'',
              mobile:'',
              work:''
          },
        }
      },

      created(){
      },
      methods: {
          save() {
              this.swalConfirmSubmit((data) => {
                  if (data.value) {
                      this.is_saving = true;
                      this.form.manpower_id = this.$route.params.id;
                      this.axios.post('maintenance/manpowers/emergency-contacts/save', this.form).then(response => {
                          this.swalTransactionCompleted();
                          this.is_saving = false;
                          this.$emit('save');
                      }).catch(error => {
                          this.swal_transaction_error_data.text = error.response.data;
                          this.swalRequestError();
                          this.is_saving = false;
                      });
                  }
              });
          },
      }
    }
</script>
